import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
const ReportsActionView = () => {
  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      <Button className='apphome-display-btn'>
        <PlusOutlined /> Personal Reports
      </Button>
    </div>
  );
};

export default ReportsActionView;
